import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=5378eeb6&scoped=true"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=5378eeb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5378eeb6",
  null
  
)

export default component.exports